<template>
  <section class="py-5">
    <div class="container">
      <div class="">
        <h1>Want to learn a skill?</h1>
        <p>Check out our training amazing programmes and tracks</p>
        <swiper
          class="learn-slider"
          :slides-per-view="1"
          :space-between="50"
          :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
          }"
          :pagination="{
            clickable: true,
          }"
          :navigation="true"
          :modules="modules"
        >
          <swiper-slide v-for="slide in 6" :key="slide">
            <div class="row">
              <div class="col-md-7">
                <div class="h-100">
                  <img
                    src="../../assets/Images/home/learn.png"
                    class="img-fluid rounded learn-image"
                    alt=""
                  />
                </div>
              </div>
              <div class="col-md-5 d-flex align-items-center">
                <div>
                    <h4>On-site Training</h4>
                <p class="mb-3">
                  Amet minim mollit non deserunt ullamco est sit aliqua dolor do
                  amet sint. Amet minim mollit non deserunt ullamco est sit
                  aliqua dolor do amet sint, amet minim mollit non deserunt
                  ullamco est sit aliqua dolor do amet sint.
                </p>
                <router-link to="#" class="btn btn-primary"
                  >Read More</router-link
                >
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";
export default {
  name: "learnSkill",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {};
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>

<style scoped>
.learn-slider {
  width: 70% !important;
  margin: 0 auto;
}

.learn-image {
    height: 400px;
}

.swiper-button-next,
.swiper-button-prev {
  color: #ffffff;
  font-size: 30px;
  z-index: 900;
  color: blue !important;
}

.swiper-button-next {
  right: 0px !important;
}

.swiper-button-prev {
  left: 0px !important;
}

.swiper {
  padding: 0 40px;
}

@media (max-width: 769px) {
  .learn-slider {
    width: 100% !important;
  }
}
</style>